
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/corporatecontent/[...slug]",
      function () {
        return require("private-next-pages/corporate/corporatecontent/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/corporatecontent/[...slug]"])
      });
    }
  